import React from "react";
import First from "./Mobile/First";
import Technology from "./Mobile/Technology";

const MobileTrainig = () => {
  return <div>
    <First/>
    <Technology/>
  </div>;
};

export default MobileTrainig;
